import { render } from "./ChartV2.vue?vue&type=template&id=50db1102&scoped=true"
import script from "./ChartV2.vue?vue&type=script&lang=js"
export * from "./ChartV2.vue?vue&type=script&lang=js"

import "./ChartV2.vue?vue&type=style&index=0&id=50db1102&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50db1102"]])

export default __exports__